import React, { useState, useEffect } from 'react';

import { Card, CardContent } from '../components/ui/card';
import { Building, Users, Camera, GitCompare } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useGetClinics ,useAdminDashboard } from '../hooks/useApi';

const SuperAdminDashboard = () => {

  
  const { data: clinicsData, isLoading: clinicsLoading } = useGetClinics('');
  const clinics = clinicsData?.data || clinicsData || [];
  const {data:dashboardData , isLoading:dashboardLoading} = useAdminDashboard();
  const statsdata = dashboardData?.data || [];
  

  const statCards = [
    {
      title: 'Total Clinics',
      value: statsdata.total_clinics || 0,
      icon: Building,
      color: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50',
    },
   
  ];

  const getPageStyle = (page) => {
    const intensity = page / totalPages;
  
    if (page === currentPage) {
      return 'bg-primary-600 text-white scale-110';
    }
  
    if (intensity < 0.4) return 'bg-gray-100 text-gray-600';
    if (intensity < 0.7) return 'bg-gray-200 text-gray-700';
    return 'bg-gray-300 text-gray-800';
  };
  

  return (
    <div className="space-y-3 sm:space-y-4 animate-fadeIn">
      {/* Welcome Section */}
     

      {/* Stats Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title} className="overflow-hidden hover:shadow-lg transition-all duration-300">
              <CardContent className="p-3 sm:p-4">
                <div className="flex items-center justify-between">
                  <div className="flex-1 min-w-0">
                    <p className="text-xs sm:text-sm font-medium text-gray-600 truncate">{stat.title}</p>
                    <p className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1">
                      {clinicsLoading && stat.title === 'Total Clinics' ? '...' : stat.value}
                    </p>
                  </div>
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-2xl ${stat.bgColor} flex items-center justify-center flex-shrink-0 ml-2`}>
                    <div className={`w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center shadow-md`}>
                      <Icon className="w-4 h-4 sm:w-6 sm:h-6 text-white" />
                    </div>
                  </div>
                </div>
              </CardContent>
                          
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;

